import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Input } from "antd";
import { NotificationManager } from "react-notifications";
import AdminToolsDataService from "../../services/admin-tools.service";

const { TextArea } = Input;

const SuggestFeature = () => {
    const { t } = useTranslation();
    const loginDetials = useSelector((state) => state.loginReducer);


    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        featureRequest: ""
    });

    const [validation, setValidation] = useState({
        firstNameVal: "",
        lastNameVal: "",
        emailVal: "",
        companyNameVal: "",
        featureRequestVal: ""
    });

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (loginDetials && loginDetials.loginDetials && loginDetials.loginDetials.responseData) {
            const userData = loginDetials.loginDetials.responseData;


            let firstName = "";
            let lastName = "";
            if (userData.userProfilename) {
                const nameParts = userData.userProfilename.split(" ");
                firstName = nameParts[0] || "";
                lastName = nameParts.slice(1).join(" ") || "";
            }

            setFormData({
                firstName: firstName,
                lastName: lastName,
                email: userData.userEmail || "",
                companyName: userData.dealerCompany || "",
                featureRequest: ""
            });
        }
    }, [loginDetials]);

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        setFormData({
            ...formData,
            [field]: value
        });


        if (validation[`${field}Val`]) {
            setValidation({
                ...validation,
                [`${field}Val`]: ""
            });
        }
    };

    const validateForm = () => {
        const newValidation = {
            firstNameVal: "",
            lastNameVal: "",
            emailVal: "",
            companyNameVal: "",
            featureRequestVal: ""
        };

        let isValid = true;

        if (!formData.firstName.trim()) {
            newValidation.firstNameVal = t("First Name is required");
            isValid = false;
        }

        if (!formData.lastName.trim()) {
            newValidation.lastNameVal = t("Last Name is required");
            isValid = false;
        }

        if (!formData.email.trim()) {
            newValidation.emailVal = t("Email Address is required");
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newValidation.emailVal = t("Please enter a valid email address");
            isValid = false;
        }

        if (!formData.companyName.trim()) {
            newValidation.companyNameVal = t("Company Name is required");
            isValid = false;
        }

        if (!formData.featureRequest.trim()) {
            newValidation.featureRequestVal = t("Feature Request is required");
            isValid = false;
        } else if (formData.featureRequest.trim().length < 10) {
            newValidation.featureRequestVal = t("Feature Request must be at least 10 characters long");
            isValid = false;
        }

        setValidation(newValidation);
        return isValid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            let inputData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                companyName: formData.companyName,
                email: formData.email,
                featureRequest: formData.featureRequest,
                dealerId: loginDetials.loginDetials.responseData.dealerId,
            };

            await new Promise(resolve => setTimeout(resolve, 1000));

            const response = await AdminToolsDataService.SendFeatureSuggestionEmail(inputData);

            if (response.data.message === "Success") {
                NotificationManager.success(
                    t("Feature suggestion submitted successfully!"),
                    t("Success"),
                    3000
                );
                setFormData({
                    ...formData,
                    featureRequest: ""
                });
            } else {
                NotificationManager.error(
                    t("Failed to submit feature suggestion. Please try again."),
                    t("Error"),
                    3000
                );
            }
        } catch (error) {
            console.error("Error submitting feature suggestion:", error);
            NotificationManager.error(
                t("Failed to submit feature suggestion. Please try again."),
                t("Error"),
                3000
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="form__fields">
                <div className="container py-5 w-70">
                    <div class="d-flex justify-content-center mb-3">
                        <h4 className="heading-title" >
                            {t("Suggest Feature")}
                        </h4>
                    </div>

                    <p class="text-center mb-5">
                        Help us improve JewelCloud by suggesting new features that would benefit you and other users.
                    </p>

                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <div class="row mb-5">
                            <div class="col-12 col-lg-5">
                                <div class="mb-4 text-start">
                                    <label class="form-label">{t("First Name")}</label><span class="text-danger">*</span>
                                    <input
                                        type="text"
                                        class={`form-control rounded-3 ${validation.firstNameVal ? 'border-danger' : ''}`}
                                        value={formData.firstName}
                                        onChange={(e) => handleInputChange(e, "firstName")}
                                        placeholder={t("Enter your first name")}
                                    />
                                    {validation.firstNameVal && (
                                        <p className="text-danger mt-1">{validation.firstNameVal}</p>
                                    )}
                                </div>
                                <div class="mb-2 text-start">
                                    <label class="form-label">{t("Email Address")}</label> <span class="text-danger">*</span>
                                    <input
                                        type="email"
                                        class={`form-control ${validation.emailVal ? 'border-danger' : ''}`}
                                        value={formData.email}
                                        onChange={(e) => handleInputChange(e, "email")}
                                        placeholder={t("Enter your email address")}
                                    />
                                    {validation.emailVal && (
                                        <p className="text-danger mt-1">{validation.emailVal}</p>
                                    )}
                                </div>

                            </div>

                            <div class="d-none d-lg-block col-lg-2"></div>

                            <div class="col-12 col-lg-5">

                                <div class="mb-4 text-start">
                                    <label class="form-label">{t("Last Name")}</label><span class="text-danger">*</span>
                                    <input
                                        type="text"
                                        class={`form-control ${validation.lastNameVal ? 'border-danger' : ''}`}
                                        value={formData.lastName}
                                        onChange={(e) => handleInputChange(e, "lastName")}
                                        placeholder={t("Enter your last name")}
                                    />
                                    {validation.lastNameVal && (
                                        <p className="text-danger mt-1">{validation.lastNameVal}</p>
                                    )}
                                </div>
                                <div class="mb-2 text-start">
                                    <label class="form-label">{t("Company Name")}</label><span class="text-danger">*</span>
                                    <input
                                        type="text"
                                        class={`form-control ${validation.companyNameVal ? 'border-danger' : ''}`}
                                        value={formData.companyName}
                                        onChange={(e) => handleInputChange(e, "companyName")}
                                        placeholder={t("Enter your company name")}
                                    />
                                    {validation.companyNameVal && (
                                        <p className="text-danger mt-1">{validation.companyNameVal}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div class="mb-4 text-center">
                            <label class="form-label d-block fw-bold">
                                {t("Feature Request")} <span class="text-danger">*</span>
                            </label>
                            <textarea
                                class={`form-control mx-auto w-80 ${validation.featureRequestVal ? 'border-danger' : ''}`}
                                rows="9"
                                cols="30"
                                value={formData.featureRequest}
                                onChange={(e) => handleInputChange(e, "featureRequest")}
                                placeholder={t("Please provide a detailed description of the feature you'd like to see. Include information about how it would help you, potential use cases, and any specific requirements.")}
                            ></textarea>
                            {validation.featureRequestVal && (
                                <p className="text-danger mt-2">{validation.featureRequestVal}</p>
                            )}
                        </div>

                        <div class="text-center">
                            <button
                                type="submit"
                                class="btn  px-5 primary-btn"
                                disabled={loading}
                            >
                                {loading ? t("Submitting...") : t("Submit Suggestion")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SuggestFeature;
